import { render } from "./UserAgreementRu.vue?vue&type=template&id=14535d54&scoped=true"
import script from "./UserAgreementRu.vue?vue&type=script&lang=js"
export * from "./UserAgreementRu.vue?vue&type=script&lang=js"

import "./UserAgreementRu.vue?vue&type=style&index=0&id=14535d54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14535d54"]])

export default __exports__